<script setup lang="ts">
import { getDateStringForDisplay } from '@@/bits/time'
import { useRelativeTime } from '@@/vuecomposables/useRelativeTime'
import { computed } from 'vue'

/**
 * Displays the duration relative to given date/time.
 */
const {
  dateformat = 'short',
  longFormat = 'approximate',
  datetime,
} = defineProps<{
  /**
   * Display the duration from this date/time.
   */
  datetime: string | number | Date
  /**
   * The format to display the relative time in.
   */
  dateformat?: 'short' | 'long'
  longFormat?: 'exact' | 'approximate'
}>()

const actualTime = computed(() => getDateStringForDisplay(datetime))
const relativeTime = useRelativeTime(datetime, dateformat, longFormat)
</script>

<script lang="ts">
export default {}
</script>

<template>
  <time :title="actualTime">{{ relativeTime }}</time>
</template>
